import React from 'react';

import { newWorker } from 'shared/services/Worker';

const GalleryWorker = props => {
  const worker = newWorker('workers/kiosk/gallery_worker.js?' + Date.now());

  const getGridDimensions = (galleryWidth, columns, moments, callback) => {
    // stringify JSON & only pass ID, width and height for each moment
    moments = JSON.stringify(moments.map(({ id, width, height }) => {
      return { id, width, height };
    }));

    let fn = 'getGridDimensions';
    let args = [galleryWidth, columns, moments];

    worker.callFunction(fn, args, callback);
  }

  // setup handle for child components
  const galleryWorker = {
    getGridDimensions
  }

  window.galleryWorker = galleryWorker;

  return React.Children.map(props.children, child => {
    return React.cloneElement(child, { galleryWorker });
  });
}

export default GalleryWorker;
